import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { QuejasComponent } from "./quejas/quejas.component";
import { EstadoCuentaComponent } from '../componentes/estado-cuenta/estado-cuenta.component';
import { CertificadoNoAdeudoComponent } from '../componentes/certificado-no-adeudo/certificado-no-adeudo.component';
import { InformacionComponent } from '../componentes/informacion/informacion.component';
import { VentanillaComponent } from '../componentes/ventanilla/ventanilla.component';
import { GenerarOrdenTrabajoComponent} from '../componentes/generar-orden-trabajo/generar-orden-trabajo.component';
import { ProrrateosComponent} from '../componentes/prorrateos-grid/prorrateos-component';
import { AuthGuard } from "app/_helpers";
import { CatDescuentosComponent } from '../componentes/cat-descuentos/cat-descuentos.component';
import { AguaDescuentosComponent } from '../componentes/agua-descuentos/agua-descuentos.component';
import { CatReportesComponent } from "app/componentes/cat-reportes/cat-reportes.component";
import { ContratosComponent } from "app/comercializacion/contratos/contratos.component";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "estadocuenta",
        component: EstadoCuentaComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "ventanilla",
        component: VentanillaComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "OrdenDeTrabajo",
        component: GenerarOrdenTrabajoComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "Prorrateos",
        component: ProrrateosComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "informacion",
        component: InformacionComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "certificado-no-adeudo",
        component: CertificadoNoAdeudoComponent,
        canActivate: [AuthGuard],
      },
    ],
  },

  {
    path: "",
    children: [
      {
        path: "quejas",
        component: QuejasComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "cat-descuentos",
        component: CatDescuentosComponent,
        canActivate: [AuthGuard],
      },
   ],
  },
  {
    path: "",
    children: [
      {
        path: "aguas-descuentos",
        component: AguaDescuentosComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "reporte-atencion",
        component: CatReportesComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "",
    children: [
      {
         path: "padron",
         component: ContratosComponent,
         canActivate: [AuthGuard],
      },
    ], 
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AtencionRoutingModule {}
